/**
 * jQuery for the last code that still needs it, the old page designer, loaded on first use so
 * the rest of the panel never downloads it.
 *
 * The designer's script and its block settings plugin read the global `$`, so the copy is set
 * there, once. `window.jQuery` is left alone: DataTables switches to
 * jQuery's events as soon as it sees one there, and a table already on the page would then stop
 * hearing its own events (its sort arrows keep the old order).
 * A copy already on the page is kept, with the plugins loaded on it, and then nothing is downloaded.
 * The app's global scripts have no jQuery (`scripts/check-jquery-on-demand.mjs` checks it).
 */

/** What this file needs of jQuery, so it does not depend on jQuery's own typings. */
interface JQueryGlobal {
  fn: {jquery: string};
}

let loading: Promise<JQueryGlobal> | undefined;

export function loadJQuery(): Promise<JQueryGlobal> {
  const global = window as unknown as {$?: JQueryGlobal; jQuery?: JQueryGlobal};
  if (global.jQuery) {
    global.$ ??= global.jQuery;
    return Promise.resolve(global.jQuery);
  }
  loading ??= import('jquery').then(({default: jQuery}) => {
    global.$ ??= jQuery;
    return jQuery;
  }, (error) => {
    // A failed download (a deploy, the network) is tried again by the next caller.
    loading = undefined;
    throw error;
  });
  return loading;
}
